import { render, staticRenderFns } from "./ClaimRequestTable.vue?vue&type=template&id=5bf40458&scoped=true&"
import script from "./ClaimRequestTable.vue?vue&type=script&lang=js&"
export * from "./ClaimRequestTable.vue?vue&type=script&lang=js&"
import style0 from "./ClaimRequestTable.vue?vue&type=style&index=0&id=5bf40458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf40458",
  null
  
)

export default component.exports